var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Stocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.94 61v4h-26l.09-.41A9.21 9.21 0 0035.9 61h26.04zM56 58H35V42h-4v-5h29v5h-4v16zm-6.12-14.5a1.5 1.5 0 00-1.5-1.5h-5.63a1.5 1.5 0 100 3h5.63a1.5 1.5 0 001.5-1.5zM35 18h-4v-5h29v5h-4v16H35V18zm6.25 1.51a1.5 1.5 0 001.5 1.5h5.63a1.5 1.5 0 100-3h-5.63a1.5 1.5 0 00-1.5 1.49v.01zM33 63a6 6 0 11-12 0 6 6 0 0112 0zm-4 0a2 2 0 00-1.13-1.79 2 2 0 00-2.59.79 1.88 1.88 0 00-.28 1 2 2 0 004 0zm-5-44.79v36.35a8.68 8.68 0 013-.56c.29 0 .67 0 1 .06V18.21A9.38 9.38 0 0019 9H9v4.58a1.71 1.71 0 001.75 1.62c2.51 0 5.83-2.21 8.73-2.21C21.86 13 24 15.62 24 18.21z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Stocks.18dbb914.svg";
export { SvgE4Stocks as ReactComponent };